import React from 'react'

interface Props {
  error?: string | null
}

const FieldError: React.FC<Props> = ({ error }: Props) => {
  if (!error) return null
  return (
    <p className="text-orange w-full flex flex-row items-baseline">
      <i className="nf-icon nf-warning-sign mr-1" />
      {error}
    </p>
  )
}

export default FieldError
